import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=80fa9eee&"
import script from "./DocumentDownload.vue?vue&type=script&lang=js&"
export * from "./DocumentDownload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDownload.vue?vue&type=style&index=0&id=80fa9eee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports